export const EXSBPRICEITEM_CREATE_RESET = 'EXSBPRICEITEM_CREATE_RESET'
export const EXSBPRICEITEM_CREATE_SET_CREATED = 'EXSBPRICEITEM_CREATE_SET_CREATED'
export const EXSBPRICEITEM_CREATE_SET_ERROR = 'EXSBPRICEITEM_CREATE_SET_ERROR'
export const EXSBPRICEITEM_CREATE_SET_VIOLATIONS = 'EXSBPRICEITEM_CREATE_SET_VIOLATIONS'
export const EXSBPRICEITEM_CREATE_TOGGLE_LOADING = 'EXSBPRICEITEM_CREATE_TOGGLE_LOADING'
